/**
 * Records the consuming application's own CDL identity so the event middleware can re-assert it
 * on every event (see `alwaysIncludeAppName`), rather than relying on the one `application` block
 * written at bootstrap — which a same-window micro-frontend can displace for the rest of the
 * page session. See DE751628 for the full background.
 */

let applicationName: string | undefined;

/** Called by `initDrCdlV3` with the consuming application's own name. */
export const setApplicationName = (name?: string): void => {
    applicationName = name;
};

/** The name recorded by `initDrCdlV3`, or `undefined` if it has not run yet. */
export const getApplicationName = (): string | undefined => applicationName;

/**
 * Clears the recorded name. Intended for tests — module-level state would otherwise leak
 * between cases.
 */
export const resetApplicationName = (): void => {
    applicationName = undefined;
};
